<template>
  <Modal v-model="connectionLost" :dismissable="false">
    <p class="pb-2 text-xl font-bold leading-tight">
      {{ $t('popups.lostConnection.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.lostConnection.description', brandInfo) }}
    </p>
    <div class="flex justify-end">
      <Button
        :href="backToLHLink"
      >
        {{ $t('popups.lostConnection.returnToLHButton', brandInfo) }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import LostConnectionPopup from '~app/psp/base/lost-connection-popup.ts'
import Button from '~brand-components/swiss/button/button.vue'
import Modal from '~brand-components/swiss/modal/modal.vue'

export default LostConnectionPopup.extend({
  components: {
    Button,
    Modal,
  },
})
</script>
